module.exports = __webpack_public_path__ + "_/common/src/assets/images/bl_kakao.png";